<template>
  <Badge v-if="isComplete" variant="green" class="gap-1">
    <vue-feather type="check-circle" size="13" />
    Completed
  </Badge>

  <div v-else class="w-full">
    <div class="mb-1.5 flex items-center justify-between text-xs font-medium" :class="labelClass">
      <span>{{ completed }} of {{ total }} lessons</span>
      <span>{{ percent }}%</span>
    </div>
    <div class="h-1.5 w-full overflow-hidden rounded-full" :class="trackClass">
      <div
        class="h-full rounded-full transition-[width] duration-500"
        :class="fillClass"
        :style="{ width: `${percent}%` }"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Badge } from '@/components/ui/badge';

const props = withDefaults(defineProps<{ completed: number; total: number; tone?: 'light' | 'dark' }>(), {
  tone: 'light',
});

const percent = computed(() => (props.total > 0 ? Math.round((props.completed / props.total) * 100) : 0));

const isComplete = computed(() => props.total > 0 && props.completed >= props.total);

const labelClass = computed(() => (props.tone === 'dark' ? 'text-white/80' : 'text-gray-500'));
const trackClass = computed(() => (props.tone === 'dark' ? 'bg-white/20' : 'bg-gray-200'));
const fillClass = computed(() => (props.tone === 'dark' ? 'bg-white' : 'bg-[#202F7E]'));
</script>
